__turbopack_context__.v({
  "desktopNavBtns": "desktop-navbar-module-scss-module__glezYW__desktopNavBtns",
  "desktopNavContentWrapper": "desktop-navbar-module-scss-module__glezYW__desktopNavContentWrapper",
  "desktopNavbar": "desktop-navbar-module-scss-module__glezYW__desktopNavbar",
  "desktopNavbarContainer": "desktop-navbar-module-scss-module__glezYW__desktopNavbarContainer",
  "logoLink": "desktop-navbar-module-scss-module__glezYW__logoLink",
  "navBtn": "desktop-navbar-module-scss-module__glezYW__navBtn",
  "navGroupLinks": "desktop-navbar-module-scss-module__glezYW__navGroupLinks",
  "navLinks": "desktop-navbar-module-scss-module__glezYW__navLinks",
  "navLinksContainer": "desktop-navbar-module-scss-module__glezYW__navLinksContainer",
  "navScrim": "desktop-navbar-module-scss-module__glezYW__navScrim",
  "overlay": "desktop-navbar-module-scss-module__glezYW__overlay",
  "subNavOpen": "desktop-navbar-module-scss-module__glezYW__subNavOpen",
  "ticketLink": "desktop-navbar-module-scss-module__glezYW__ticketLink",
  "transitionsSuspended": "desktop-navbar-module-scss-module__glezYW__transitionsSuspended",
});
